import {
  createPlan,
  searchPlan,
  searchPlanWeek,
  searchPlanOneDay,
  searchLastInUsePlan,
  deleteTurnOfPlan,
  reservePlan,
  updateForCome,
  updateForMove,
  findInUsePlan,
  getTurnInfo,
  searchForTurn,
  turnHistory,
  ReferenceHistory
} from "@/services/endpoints/plans";
import axios from "../../services/axios";

export default {
  async createPlan({ commit }, payload) {
    try {
      let res = await createPlan(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchPlan({ commit }, payload) {
    try {
      let res = await searchPlan(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchPlanWeek({ commit }, payload) {
    try {
      let res = await searchPlanWeek(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchPlanOneDay({ commit }, payload) {
    try {
      let res = await searchPlanOneDay(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchLastInUsePlan({ commit }, payload) {

    try {
      let res = await searchLastInUsePlan(payload);;
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async deleteTurnOfPlan({ commit }, payload) {
    try {
      let res = await deleteTurnOfPlan(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async reservePlan({ commit }, payload) {
    try {
      let res = await reservePlan(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async updateForCome({ commit }, payload) {
    try {
      let res = await updateForCome(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async updateForMove({ commit }, payload) {
    try {
      let res = await updateForMove(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async findInUsePlan({ commit }, payload) {
    try {
      let res = await findInUsePlan(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchForTurn({ commit }, payload) {
    try {
      let res = await searchForTurn(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async getTurnInfo({ commit }, payload) {
    try {
      let res = await getTurnInfo(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async turnHistory({ commit }, payload) {
    try {
      let res = await turnHistory(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async ReferenceHistory({ commit }, payload) {
    try {
      let res = await ReferenceHistory(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
};
